const config = {
    type: 'MULTIMEDIA',
    component: "Smu07",
    portrait: "/img/container/S-MU-07.jpg",
    body: {
        title: '',
        image: "https://placehold.co/600x300?text=Selecciona+o+arrastra+tu+imagen",
        content:''
    },
}

export { config }